import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { celebrate } from '../utils/confetti'
import ImageSlider from './imageSlider'
import { trackEvent } from '../analytics/client'
import { ANALYTICS_EVENTS } from '../analytics/events'

const Box = styled.div`
  text-align: center;
  color: #333;

  h1.egg {
    cursor: pointer;
  }
  
  h1.title {
    margin-bottom: 32px;
  }
  
  img {
    border-radius: 10px;
  }
`

const imageBase = 'https://dhcabdjaij1gf.cloudfront.net/'

const imageUrls = [
  'hickey.jpg',
  'nville.png',
  'rv.jpg',

  'broadway.JPG',
  'fdate.JPG',
  'ring.jpg',
  
  'cotton.jpg',
  'office.JPEG',
  'eclipse.jpg',
  'bed.jpg',
  'airport.jpg',
  'lake.jpg',
  'mila.jpg',
  'jetski2.jpg',
  'infuse.jpg',
  'rat.jpg',
  'photo.jpg',
  'phone.jpg',
  'nye.jpg',
  'sunset.jpg',
  'sad.PNG',
]

const SOCKET_URL = process.env.NODE_ENV === 'production' ? window.location.origin : process.env.API_URL

const MorgoEgg = () => {
  const socket = useRef(null)
  const audio = useRef(null)

  useEffect(() => {
    celebrate(2900, true)
  }, [])

  useEffect(() => {
    if (socket.current) {
      return
    }
    const userToken = localStorage.getItem('userToken')
    socket.current = io(SOCKET_URL)
    socket.current.on('connect', () => {
      socket.current.emit('morgo', { userToken })
    })
    trackEvent(ANALYTICS_EVENTS.FUN_MORGO_EGG)
  }, [])

  const onRestartAudio = () => {
    if (!audio.current) {
      return
    }
    if (audio.current.paused) {
      audio.current.currentTime = 0
      audio.current.play()
    } else {
      audio.current.pause()
    }
  }

  const fullImageUrls = imageUrls.map(url => `${imageBase}${url}`)

  return (
    <Box>
      <h1 className='egg' onClick={onRestartAudio}>🦚</h1>
      <h1 className='title'>Morgo Baby</h1>
      <p>Cuddle <strong><em>puzzle</em></strong> touch love!</p>
      <p>Miss kiss AND kiss miss!</p>
      <p>Falling (<em>for you</em>).</p>
      <p>No matter? <em>Literally what.</em></p>
      <p>Just you. Always just you.</p>
      {/* <br /><br /> */}
      <p>My favorite ever.</p>
      <p>I love endlessly.</p>
      <p><em>Come sleep with me?</em></p>
      <p>Never let go.</p>
      <br /><br />
      <p>Never let go.</p>
      <br />
      <audio autoPlay ref={audio}>
        <source src="https://dhcabdjaij1gf.cloudfront.net/running.mp3" type="audio/mpeg" />
      </audio>
      <ImageSlider images={fullImageUrls} />
      <br /><br /><br />
      Yours forever and always, Nick.
      <br /><br />
    </Box>
  )
}

export default MorgoEgg
